import { useState } from "react";
import "./styles.scss";
import General from "./general";
function UserProfile() {
    return (
        <div className="alternateView">
            <div className="col1">
                <div className="header">User Profile</div>
                <div className="selectedPreference">Details</div>
            </div>
            <div className="col2">
                <General></General>
            </div>
        </div>
    );
}
export default UserProfile;
